module.exports = "<div (focusin)=\"focusin()\">\n  <asi-autocomplete #autocomplete (onRequestData)=\"requestData($event)\" [datas]=\"filteredData\" [(ngModel)]=\"value\">\n  <ng-template #selected let-data=\"data\">{{data?.libelle}}</ng-template>\n  <ng-template #option let-data=\"data\"><span class=\"truncate\">{{data?.libelle}}</span></ng-template>\n</asi-autocomplete>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/digicerba-modules/digicerba-paiement-factures/digicerba-paiement-factures-web/src/angular/cerba/src/app/common/utils/autocomplete/autocomplete.component.html
// module id = ../../../../../src/app/common/utils/autocomplete/autocomplete.component.html
// module chunks = 1